import defaultState from "./state";

const grillaBusquedaAGReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "CARGAR_MODAL_OBSERVACION": {
      return Object.assign({}, state, {
        openModal: action.openModal,
        observacion: action.observacion,
        idPaqueteObservacion: action.idPaquete,
      });
    }

    case "CERRAR_MODAL_OBSERVACION": {
      return Object.assign({}, state, {
        openModal: action.cerrar,
      });
    }

    case "CAMBIAR_OBSERVACION": {
      return Object.assign({}, state, {
        observacion: action.observacion,
      });
    }

    case "ABRIR_MODAL_CARACTERISTICAS": {
      return Object.assign({}, state, {
        openModalCaracteristicas: action.openModal,
        caracteristicasPaquete: action.caracteristicas,
      });
    }

    case "CERRAR_MODAL_CARACTERISTICAS": {
      return Object.assign({}, state, {
        openModalCaracteristicas: action.cerrar,
      });
    }

    case "ABRIR_MODAL_DETALLE": {
      return Object.assign({}, state, {
        openModalDetalle: action.openModal,
        detallePaquete: action.detalles,
        totalClinica: action.totalClinica,
        totalHMQ: action.totalHMQ,
        totalMonto: action.totalMonto,
      });
    }

    case "CERRAR_MODAL_DETALLE": {
      return Object.assign({}, state, {
        openModalDetalle: action.cerrar,
      });
    }

    case "GUARDAR_OBSERVACION": {
      if (state.observacionesGuardadas.length === 0) {
        return Object.assign({}, state, {
          observacionesGuardadas: [{ idPaquete: action.idPaquete, observacion: action.observacion }],
        });
      } else {
        var newArray = state.observacionesGuardadas;
        var newArray2 = [];
        if (newArray.filter((item) => (item.idPaquete === action.idPaquete)).length > 0) {
          newArray2 = newArray.filter((item) => (item.idPaquete != action.idPaquete));
          newArray2.push({ idPaquete: action.idPaquete, observacion: action.observacion });
          newArray = newArray2
        } else {
          newArray.push({ idPaquete: action.idPaquete, observacion: action.observacion });
        }
        return Object.assign({}, state, {
          observacionesGuardadas: newArray,
        });
      }
    }

    case "CARGAR_EDITAR_PRESTACION": {
      return Object.assign({}, state, {
        modalEditarPrestacion: action.modalEditarPrestacion,
      });
    }

    case "CAMBIAR_PRESTACION_ELIMINAR": {
      return Object.assign({}, state, {
        idPrestacionEliminar: action.idPrestacionEliminar,
      });
    }

    case "CAMBIAR_PRESTACION_EDITAR": {
      return Object.assign({}, state, {
        idPrestacionEditar: action.idPrestacionEditar,
      });
    }


    // Reducers should always return a default initial state.
    default:
      return state;
  }
};

export default grillaBusquedaAGReducer;



// WEBPACK FOOTER //
// ./src/components/ArancelGES/GrillaBusquedaArancelGES/reducer.js